import {createContext, useState, useEffect} from 'react';
import BACKEND from 'consts/backend.consts';
import {io} from 'socket.io-client';

const AuthenticationContext = createContext();
export default AuthenticationContext;

const SOCKET_STATUS = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  CONNECTING: 'CONNECTING'
};

export function AuthenticationContextProvider(props) {
  const [userAuth, setUserAuth] = useState();
  const [user, setUser] = useState();
  const [socket, setSocket] = useState();
  const [statusSocket, setStatusSocket] = useState(SOCKET_STATUS.CONNECTING);

  const userDefault = {
    email: 'liverpool@neored.com',
    uid: '12345678',
    role: 'ADMIN'
  };

  useEffect(() => {
    setUserAuth({
      uid: userDefault.uid,
      email: userDefault.email
    });
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if(userAuth !== undefined && userAuth !== null) {
          const authorization = userAuth.uid;
          const socket = io(BACKEND.BASE_URL, {
            transports: ['websocket'],
            auth: {
              token: authorization
            },
            query: {
              source: "WEB",
            }
          });
          socket.on('connect', () => {
            getDataAccount();
            setStatusSocket(SOCKET_STATUS.CONNECTED);
          });
          socket.on('connect_error', (err) => {
            console.error(err);
            setStatusSocket(SOCKET_STATUS.DISCONNECTED);
          });
          Object.entries(socketListeners).forEach(([eventName, eventFn]) => {
            socket.off(eventName);
            socket.on(eventName, eventFn);
          })
          setSocket(socket);
        } 
        else {
          if(socket) { socket.close(); }
          setSocket(null);
          setUser(userAuth === undefined ? undefined : null);
        }
      }
      catch(error) {
        setStatusSocket(SOCKET_STATUS.DISCONNECTED);
      }
    })();
    return () => {
      if(socket) {
        Object.entries(socketListeners).forEach(([eventName]) => {
          socket.off(eventName);
        })
        socket.close();
      }
    }
  }, [userAuth]);

  const getDataAccount = async () => {
    const user = userDefault;
    const responseRole = { payload: 'ADMIN' };
    user.role = responseRole.payload;
    setUser(user);
  }

  const socketListeners = {
    ping: (params, callback) => {
      if(typeof callback === 'function') {
        callback({
          responseAt: new Date()
        });
      }
    }
  }

  return (
    <AuthenticationContext.Provider value={{user, getDataAccount, socket, statusSocket}}>
      {props.children}
    </AuthenticationContext.Provider>
  );
}